import { ConversationChannelUpdatedEntry } from 'lib-shared-legacy-types';

import { LogEntry } from './logEntry';

type ConversationChannelUpdatedProps = {
  entry: ConversationChannelUpdatedEntry;
};

export const ConversationChannelUpdated = ({
  entry,
}: ConversationChannelUpdatedProps): JSX.Element => {
  const text = <>Conversation channel updated to {entry.channel}</>;
  return <LogEntry entry={entry} text={text} />;
};
